<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="22">
            <a-form-item label="关键词">
              <a-input v-model.trim="queryParam.keyWord" placeholder="师傅名称\师傅电话" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="22">
            <a-form-item label="审核状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 5px">
              <a-select v-model.trim="queryParam.status" @change="installChange" :allowClear="true">
                <a-select-option v-for="type in anthNameList" :title="type.dictLabel" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="22">
            <a-form-item label="申请开始日期" style="margin-left: 5px">
              <a-date-picker
                v-model="queryParam.startTime1"
                style="width: 100%"
                show-time
                :disabled-date="disabledStartDate"
                format="YYYY-MM-DD"
                @change="onChange1"
                @ok="onOk1"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="22">
            <a-form-item label="申请结束日期">
              <a-date-picker
                v-model="queryParam.endTime1"
                style="width: 100%"
                show-time
                :disabled-date="disabledEndDate"
                format="YYYY-MM-DD"
                @change="onChange2"
                @ok="onOk2"
              />
            </a-form-item>
          </a-col>

          <a-col :span="22" style="text-align: right; margin-right: 8px">
            <a-button type="primary" htmlType="submit" style="margin-right: 8px" @click="$refs.table.refresh(true)"
              >查询</a-button
            >
            <a-button style="margin-left: 8px" @click="() => (queryParam = {})">清空</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator"></div>
    <s-table size="default" ref="table" rowKey="id" :columns="columns" :data="loadData" bordered>
      <span slot="action" slot-scope="text, record">
        <a v-if="record.status==3" @click="examineSuccess(record)">通过</a> 
        <a-divider v-if="record.status==3" type="vertical" />
        <a v-if="record.status==3" @click="examine(record.teamExamineId)">拒绝</a>
        <a v-if="record.status!=3" @click="deleteExamine(record.teamExamineId)">删除</a>
      </span>
    </s-table>

    <a-modal
        title="拒绝原因"
        style="top: 20px"
        :width="800"
        v-model="removeible"
        :confirmLoading="confirmLoading"
        @ok="confirmOk"
        @cancel="confirmCancel"
      >
        <a-form ref="ruleForm" :form="form">
          <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              type="textarea"
              v-model="refuseText"
            />
          </a-form-item>
        </a-form>
      </a-modal>
  </a-card>



</template>



<script>
import { STable } from '@/components'
import pick from 'lodash.pick'
import moment from 'moment'
import { queryIdList,apply,deleteData } from '@/api/master/disbandTeamList'
import { checkPermission } from '@/utils/permissions'
import NoAuthority from '../enterprise/NoAuthority'
import { getfinddictAll} from '@/api/order/orderList'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'TableList',
  components: {
    STable,
    NoAuthority,
  },
  data() {
    return {
      data: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      // 查询参数
      queryParam: {},
      // 字典为类型
      anthNameList: [],
      removeible: false,
      refuseText: '',
      examineId:'',
      // 表头
      columns: [
        {
          title: '姓名',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '电话',
          align: 'center',
          dataIndex: 'phonenumber',
        },
        {
          title: '申请日期',
          align: 'center',
          dataIndex: 'applyTime',
        },
         {
          title: '审核状态',
          align: 'center',
          dataIndex: 'statusName',
        },
        {
          title: '操作',
          width: '60px',
          dataIndex: 'action',
           align: 'center',
          scopedSlots: { customRender: 'action' },
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        this.queryParam.type ='1';
        return queryIdList(Object.assign(parameter, this.queryParam))
      },
      selectedRowKeys: [],
      selectedRows: [],
    }
  },
  filters: {},
  async created() {
    let dictTypes = ['team_examine_ststus']
    getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
      this.anthNameList = res.team_examine_ststus
    })
  },

  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleOk() {
      this.$refs.table.refresh(true)
      console.log('handleSaveOk')
    },

    // 品牌
    changeBrandName(e) {
      this.queryParam.brandId = e
    },

    onChange1(value, dateString) {
      this.queryParam.startTime = dateString
    },
    onChange2(date, dateString) {
      this.queryParam.endTime = dateString
    },
    
     
    async confirmOk() {
      if(this.refuseText==''){
        this.$message.error('请填写原因');
        return ;
      }
      apply({
          id: this.examineId,
          status: "2",
          remark:this.refuseText
        }).then((res) => {
          this.removeible = false
          this.removeLoading = false
           if(res.code==0){
           this.$message.success('已拒绝')       
          this.$refs.table.refresh(true)
          }else{
          this.$message.error(res.msg)       
           this.$refs.table.refresh(true)
          }
        })
    },
    // 取消时调用的方法
    confirmCancel() {
      this.removeible = false

    },
    examine(id) {
      this.examineId=id;
      this.refuseText = '';
      this.removeible = true

    },
    examineSuccess(record) {
         apply({
          id: record.teamExamineId,
          status: "1",
          remark:this.refuseText
        }).then((res) => {
          if(res.code==0){
           this.$message.success('审核通过')       
           this.$refs.table.refresh(true)
          }else{
          this.$message.error(res.msg)       
           this.$refs.table.refresh(true)
          }
        })
    },

    deleteExamine (id) {
      let that = this
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
          deleteData({
          id: id
        }).then((res) => {
        if(res.code==0){
          that.$message.success('删除成功')    
          that.$refs.table.refresh(true) 
          }else{
          this.$message.error(res.msg)       
           this.$refs.table.refresh(true)
          }  
        })
      },
          onCancel() {
            console.log('Cancel');
          },
        });
    },

  },
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
